import Participants from './participants';
import Enrollment from './enrollments';
import Kitchen from './kitchen';
import Medical from './medical';
import Media from './media';
import Archive from './archive';

export default function Pages(props) {
    return {
        Participants,
        Enrollment,
        Kitchen,
        Medical,
        Media,
        Archive,
    };
}
